module.exports = __webpack_public_path__ + "fonts/Quicksand-300-latin-ext2.29b81f3.woff2";